module.exports = __webpack_public_path__ + "img/ic_college_default.85c26d7a.png";